var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation } from '@tanstack/react-query';
import { useLucidSdk } from '#context';
const LUCIDLINK_ZENDESK_URL_PATTERN = /lucidlink(\d+)?\.zendesk\.com(\/.*)?|support\.lucidlink\.com(\/.*)?/;
export const isZendeskRedirect = (returnTo) => {
    return Boolean(returnTo) && LUCIDLINK_ZENDESK_URL_PATTERN.test(returnTo);
};
export const useGenerateZendeskVerificationCode = ({ onError, }) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const { mutateAsync: createVerificationCode } = useMutation({
        mutationFn: () => lucidSdk.zendeskClient().createVerificationCode(),
        onError: () => {
            onError?.();
        },
    });
    return { createVerificationCode };
};
_react_refresh_temp_1(useGenerateZendeskVerificationCode, "JoOAfMNcY2jaqVVK+8KuWf1f+KM=", false, () => [useLucidSdk, useMutation]);
